import moment from 'moment';
import { setTimezoneWithoutAlteringTime } from 'utils/utility_functions/timezone';

/**
 * Get page limit from user context based on module type and time entry type
 * @param {boolean} isLeadSpecific - Whether it's from leads module
 * @param {boolean} isFromCaseSpecificModule - Whether it's from case module
 * @param {boolean} isFromBilling - Whether it's from billing module
 * @param {boolean} onTimeManageMent - Whether it's from time management settings
 * @param {boolean} is_automated - Whether it's automated time entries
 * @param {Object} userContext - User context object
 * @returns {number|undefined} - Page limit or undefined
 */
export const getPageLimit = (isLeadSpecific, isFromCaseSpecificModule, isFromBilling, onTimeManageMent, is_automated, userContext) => {
  if (isLeadSpecific && userContext) {
    return is_automated
      ? userContext?.firmDetails?.pagination_preference?.leads?.billings?.automated_time_entries
      : userContext?.firmDetails?.pagination_preference?.leads?.billings?.manual_time_entries;
  } else if (isFromCaseSpecificModule && userContext) {
    return is_automated
      ? userContext?.firmDetails?.pagination_preference?.case?.billings?.automated_time_entries
      : userContext?.firmDetails?.pagination_preference?.case?.billings?.manual_time_entries;
  } else if (onTimeManageMent && userContext) {
    return is_automated
      ? userContext?.firmDetails?.pagination_preference?.settings?.time_manager?.automated_time_manager
      : userContext?.firmDetails?.pagination_preference?.settings?.time_manager?.manual_time_manager;
  } else if (isFromBilling && userContext) {
    return is_automated
      ? userContext?.firmDetails?.pagination_preference?.billings?.automated_time_entries
      : userContext?.firmDetails?.pagination_preference?.billings?.manual_time_entries;
  }
};

/**
 * Get file path for pagination preferences
 * @param {boolean} isLeadSpecific - Whether it's from leads module
 * @param {boolean} isFromCaseSpecificModule - Whether it's from case module
 * @param {boolean} onTimeManageMent - Whether it's from time management settings
 * @param {boolean} is_automated - Whether it's automated time entries
 * @returns {Object} - Path object with module, subModule, and listName
 */
export const getFilePathForPagination = (isLeadSpecific, isFromCaseSpecificModule, onTimeManageMent, is_automated) => {
  if (isLeadSpecific) {
    return {
      module: 'leads',
      subModule: 'billings',
      listName: is_automated ? 'automated_time_entries' : 'manual_time_entries',
    };
  } else if (isFromCaseSpecificModule) {
    return {
      module: 'case',
      subModule: 'billings',
      listName: is_automated ? 'automated_time_entries' : 'manual_time_entries',
    };
  } else if (onTimeManageMent) {
    return {
      module: 'settings',
      subModule: 'time_manager',
      listName: is_automated ? 'automated_time_manager' : 'manual_time_manager',
    };
  } else {
    return {
      module: 'billings',
      subModule: '',
      listName: is_automated ? 'automated_time_entries' : 'manual_time_entries',
    };
  }
};

/**
 * Extract date range from date array and format for API
 * @param {Array} dateArray - Array of dates [startDate, endDate]
 * @param {string} timezone - Timezone string from userContext.userDetails.timezone
 * @returns {Object} - Object with time_entry_from and time_entry_to
 */
export const pickExtractedDate = (dateArray, timezone) => {
  return {
    time_entry_from: dateArray?.[0] ? setTimezoneWithoutAlteringTime(moment(dateArray[0]).startOf('day'), timezone) : '',
    time_entry_to: dateArray?.[0]
      ? setTimezoneWithoutAlteringTime(moment(dateArray[1] ? dateArray[1] : dateArray[0]).endOf('day'), timezone)
      : '',
  };
};
